// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Activité',
    ai: 'IA',
    ai_analyzing: 'Analyse des modèles',
    ai_building: 'Construction de modèle de prévision',
    ai_description: 'La prévision IA {brandName} utilise des algorithmes d\'apprentissage automatique pour trouver des modèles et des relations entre les événements et les actions en traitant les données historiques de votre compte. En conséquence, elle indiquera la date de fin de projet la plus probable et son degré de confiance concernant cette prévision.',
    ai_forecast: 'Prévision IA',
    ai_forecast_date: 'Date de fin du projet prévue par l\'IA',
    ai_how_works: 'En savoir plus sur le fonctionnement de l\'IA',
    ai_not_enough_data: 'Pas assez de données historiques pour fournir une prévision fiable. L\'utilisation active du système garantira des prévisions plus précises. <a href={0} target=\'_blank\' class={1}>En savoir plus</a> sur les prévisions de l\'IA.',
    ai_planned_date: 'Date de fin prévue du projet',
    ai_result: 'Résultats des prévisions de l\'IA',
    ai_reviewing: 'Examen des données historiques',
    apply: 'Appliquer',
    available: 'Disponible',
    back: 'Retour',
    CanChangeWorkflowForProjectOutdatedData: 'Le flux de travail est déjà appliqué pour le projet. Veuillez actualiser la page pour actualiser les données.',
    CanDeleteCategoryHasTask: 'Il est impossible de supprimer une catégorie qui est utilisée par des activités.',
    CanDeletePriorityHasProject: 'Il est impossible de supprimer une priorité qui est utilisée par des projets.',
    CanDeletePriorityHasTask: 'Il est impossible de supprimer une priorité qui est utilisée par des activités.',
    CanDeletePriorityIsInternal: 'Il est impossible de supprimer une priorité interne au système.',
    CanDeleteStatusIsWorkflowTypeStatus: 'Il est impossible de supprimer le statut par défaut.',
    CanDeleteStatusUsed: 'Il est impossible de supprimer un statut utilisé dans une entité.',
    CanDeleteThresholdIsInternal: 'Il est impossible de supprimer le seuil du système interne.',
    CanDeleteVacationTypeDefault: 'Il est impossible de supprimer le type de congé par défaut.',
    CanDeleteVacationTypeHasVacation: 'Il est impossible de supprimer un type de congés qui a des congés assignés.',
    CanDeleteWorkflowIsSingle: 'Il doit y avoir au moins un flux de travail dans le système.',
    CanDeleteWorkflowIsUsed: 'Il est impossible de supprimer un flux de travail utilisé dans des projets.',
    CanDisableStatusIsUsed: 'Il est impossible de désactiver un statut utilisé dans une entité',
    CanDisableStatusIsWorkflowTypeStatus: 'Il est impossible de désactiver le statut par défaut',
    CanEdit_Task_AccessDenied: 'Vous n\'avez pas l\'autorisation de modifier cette activité',
    CanEditValueThresholdIsInternal: 'Les valeurs seuils prédéfinies du système ne peuvent pas être modifiées.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Il est impossible de marquer le statut par défaut pour un statut déjà configuré par défaut.',
    change: 'modifier',
    ChangeProjectProgressError: 'La progression d\'un projet comprenant des tâches ne peut pas être modifiée.',
    ChangeTaskProgressError: 'La progression d\'une tâche parent ne peut pas être modifiée.',
    Completed_Projects: 'Projets terminés',
    Completed_Tasks: 'Activités terminées',
    Copy_Text: 'Copier',
    copyPostfix: 'Copier',
    description_title: 'Description',
    Edit_Text: 'Modifier',
    empty_list: 'Aucun résultat correspondant à la requête de recherche/au filtre appliqué n\'a été trouvé',
    error_reload: 'La version de {brandName} a été mise à jour. Pour assurer le bon fonctionnement de l\'application, veuillez recharger la page.',
    export_csv: 'Exporter au format CSV',
    export_pdf: 'Exporter au format PDF',
    filters: 'Filtres',
    freeze: 'Geler la colonne',
    from: 'De',
    general: 'Général',
    global_search_text: 'Rechercher des messages, fichiers et plus encore',
    GotIt: 'Compris',
    here: 'ici',
    in: 'dans',
    in_use: 'Utilisé',
    label_custom_date_range: 'Plage de dates personnalisée',
    label_daily: 'Tous les jours',
    label_monthly: 'Tous les mois',
    label_weekly: 'Toutes les semaines',
    least_likely: 'Moins probable',
    month: 'Mois',
    MoreActions: 'Plus d\'actions',
    most_likely: 'Plus probable',
    name_title: 'Nom',
    next_month: 'Prochain mois',
    next_week: 'Prochaine semaine',
    no: 'Non',
    no_available_filters: 'Aucune valeur disponible pour le filtre',
    no_data_to_display: 'Aucune donnée à afficher',
    not_calculated: 'Non calculé',
    not_in_use: 'Non utilisé',
    PortfolioLimitError: 'Vous avez atteint la limite de 60 portefeuilles dans Team Edition. Veuillez effectuer une mise à niveau vers {brandName} Enterprise Edition.',
    previous_month: 'Mois précédent',
    previous_week: 'Semaine précédente',
    previous_year: 'Année précédente',
    quarter: 'Trimestre',
    quick_search_placeholder: 'Tapez pour rechercher par nom ou identifiant',
    read_more: 'Lire la suite',
    RecordConversionToActivityDifferentWorkflows: 'Il est impossible de convertir l\'enregistrement, car différents flux de travail ont été appliqués au projet et au modèle.',
    role: 'Rôle',
    select: 'Sélectionner',
    share: 'Partager',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    show_template: 'Afficher: {0}',
    sort: 'Trier',
    sort_activities: 'Trier les activités par:',
    sort_ascending: 'Trier par ordre croissant',
    sort_az: 'Trier de A→Z',
    sort_descending: 'Trier par ordre décroissant',
    sort_projects: 'Trier les projets par:',
    sort_za: 'Trier de Z→A',
    start_analyze: 'Démarrer l\'analyse',
    sub_features_list_title: 'Cette fonctionnalité comprend :',
    SystemTaskCreatorName: 'Système',
    Task_CanAccessBillingInformation_AccessDenied: 'Vous n\'avez pas l\'autorisation de modifier les paramètres de facturation de cette activité',
    this_month: 'Ce mois',
    this_week: 'Cette semaine',
    this_year: 'Cette année',
    ThresholdValueDuplicate: 'Cette valeur seuil a déjà été ajoutée.',
    to: 'À',
    today: 'Aujourd\'hui',
    unfreeze: 'Dégeler la colonne',
    UnknownErrorMessage: 'Nous sommes désolés, une erreur s\'est produite... Veuillez actualiser la page.',
    upgrade: 'Mettre à niveau',
    upgrade_to_enterprise: 'Mettre à niveau vers la version Enterprise',
    week: 'Semaine',
    WindowUnload_UnsavedChanges: 'Il y a des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?',
    year: 'Année',
    yes: 'Oui',
    yesterday: 'Hier',
};
